import { PropsWithChildren, useEffect } from 'react';
import { AuthProvider, AccountDataProvider, UserAccountsProvider, AuthMethodsProvider, BasketMonitorProvider } from '@trader-dashboard/shared';
import { TooltipProvider } from '@/components/ui/tooltip';
import { FundsProvider } from './FundsContext';
import { OrdersProvider } from './OrdersContext';
import { ProfitTrendsProvider } from './ProfitTrendsContext';
import { EventsProvider } from './EventsContext';
import { TransactionalOrdersProvider } from './TransactionalOrdersContext';
import { appFirebaseAuth, firebaseApp } from './firebase/firebase';
import { ApiFactoryInstance } from '@/api';
import { ApiFactoryInstance as SharedApiFactoryInstance } from '@trader-dashboard/shared';

export const RootProvider = ({ children }: PropsWithChildren): React.ReactNode => {
  useEffect(() => {
    // Initialize both web and shared ApiFactory instances with the Firebase app
    if (firebaseApp) {
      ApiFactoryInstance.onFirebaseAppChange(firebaseApp);
      SharedApiFactoryInstance.onFirebaseAppChange(firebaseApp);
    }
  }, []);

  return (
    <AuthProvider appFirebaseAuth={appFirebaseAuth}>
      <AuthMethodsProvider>
        <UserAccountsProvider>
          <AccountDataProvider>
            <TooltipProvider>
              <FundsProvider>
                <TransactionalOrdersProvider>
                  <OrdersProvider>
                    <ProfitTrendsProvider>
                      <EventsProvider>
                        <BasketMonitorProvider>
                          {children}
                        </BasketMonitorProvider>
                      </EventsProvider>
                    </ProfitTrendsProvider>
                  </OrdersProvider>
                </TransactionalOrdersProvider>
              </FundsProvider>
            </TooltipProvider>
          </AccountDataProvider>
        </UserAccountsProvider>
      </AuthMethodsProvider>
    </AuthProvider>

  );
};
